import { useQuery } from '@tanstack/react-query';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { Skeleton } from '@mui/material';

import { riskQueries } from '@repo/api/risk/risks';
import { Activity } from '@repo/features/activity';

import { Route as riskRoute } from '~pages/_risks/risk.$riskId/_risk/index';

export const Route = createFileRoute('/_risks/risk/$riskId/_risk/activity')({
	beforeLoad: ({ params, context }) => {
		if (!context.user?.permissions.includes('risk.activitylog.view')) {
			throw redirect({
				to: riskRoute.to,
				params,
			});
		}
	},
	component: function ActivityPage() {
		const { riskId } = Route.useParams();

		const { data: activity, isLoading } = useQuery(
			riskQueries.activity(riskId),
		);
		if (isLoading) return <Skeleton height={60} />;

		return <Activity activity={activity} />;
	},
	head: (ctx) => ctx.match.context.setTitle('Risk', 'Activity'),
});
